import { put } from "typed-redux-saga"
import { authActions } from "../state"

export function* logoutSaga() {
  yield* put(authActions.setAnonymous())
}
